/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

export interface TicketDTO {
  id: string;
  caseNumber: number;
  tailNumber: string;
  subject: string;
  createdDate: string;
  updatedDate: string;
  priority: string;
}

export interface Ticket {
  id: string;
  caseNumber: number;
  tailNumber: string;
  subject: string;
  createdDate: Date;
  updatedDate: Date;
  priority: string;
}

export function ticketFromDTO(t: TicketDTO): Ticket {
  return {
    ...t,
    createdDate: new Date(t.createdDate),
    updatedDate: new Date(t.updatedDate),
  };
}
